const homeListConfig = {
  //======================教师课程配置========================
  teacherCourseConfig:{
    title:'学校管理人员课程',//标题
    showTitle:true,//是否显示头部
    moreBtn:{
      showMoreBtn:true,//是否显示更多
      linkUrl:'#/online-learning/teacher-course/0'//更多的链接地址
    },
    tabs:{
      showTabs:false,//是否显示切换标签
      labels:[//标签名称
        {labelName:'教学能力',key:''},
        {labelName:'教学方法',key:''},
        {labelName:'信息化教学',key:''},
      ]
    },
    list:'#fff',//列表背景色
    showTeacher:false,//是否展示教师信息
    showSchool:true,
  },
  //======================学生课程配置========================
  studentCourseConfig:{
    title:'从业人员课程',//标题
    showTitle:true,//是否显示头部
    moreBtn:{
      showMoreBtn:true,//是否显示更多
      linkUrl:'#/online-learning/student-course/0_0'//更多的链接地址
    },
    tabs:{
      showTabs:false,//是否显示切换标签
      labels:[//标签名称
        {labelName:'小学',key:''},
        {labelName:'初中',key:''},
        {labelName:'高中',key:''},
      ]
    },
    list:'#F5F5F5',//列表背景色
    showTeacher:false,//是否展示教师信息
    showSchool:true,//是否显示学校
  },
  //======================家长课程配置========================
  parentCourseConfig:{
    title:'供餐企业管理人员课程',//标题
    showTitle:true,//是否显示头部
    moreBtn:{
      showMoreBtn:true,//是否显示更多
      linkUrl:'#/online-learning/parent-course/0'//更多的链接地址
    },
    tabs:{
      showTabs:false,//是否显示切换标签
      labels:[//标签名称
        {labelName:'亲子',key:''},
        {labelName:'育儿方法',key:''},
        {labelName:'家庭教育',key:''},
      ]
    },
    list:'#fff',//列表背景色
    showTeacher:false,//是否展示教师信息
    showSchool:true,
  },
  //======================平台使用教程配置========================
  platformCourseConfig:{
    title:'宣传视频',//标题
    showTitle:true,//是否显示头部
    moreBtn:{
      showMoreBtn:true,//是否显示更多
      linkUrl:'#/online-learning/platform-course/0'//更多的链接地址
    },
    tabs:{
      showTabs:false,//是否显示切换标签
    },
    list:'#F5F5F5',//列表背景色
    showTeacher:false,//是否展示教师信息
    showSchool:true,
  },
}


export default homeListConfig;
